<template>
  <gac-popup v-model="visible" position="center">
    <div class="dialog-body">
      <div class="dialog-body-content">
        <div class="content">
          <div class="close">
            <div class="title">支付定金</div>
            <div @click="visible = false">
              <img
                class="icon-close"
                src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114037202-icon_Close.png"
              />
            </div>
          </div>
          <div class="box" id="box">
            <img id="scanimg" :src="detail.payQrCode" class="img" />
            <div class="price">{{ detail.price }}</div>
            <div class="scan">
              <img
                class="scan-img"
                src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114050265-icon_weixim2.png"
              />
              <div class="scan-text">微信扫一扫，支付定金</div>
            </div>
            <div class="save-text">长按二维码保存到手机</div>
          </div>
        </div>
      </div>
    </div>
  </gac-popup>
</template>

<script>
// import { longPress, saveSharePic, longPressSave } from "@utils/longPressSave";
import { getStatus } from "@api/optional";
import GacPopup from "@components/DialogMask/index.vue";
import { getConfirm } from "@/components/Login/popupLogin";
export default {
  name: "payDialog", // 支付定金弹窗
  components: {
    GacPopup,
  },
  props: {
    detail: {
      type: Object,
      default: {},
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    visible: {
      get() {
        if (this.value) {
          this.loopStatus();
        } else {
          clearTimeout(this.timer);
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        // 关闭二次提示
        if (val === false) {
          return getConfirm().open({
            title: "取消支付？",
            content:
              "就差最后一步您就能成为合创车主，率先体验超越期待的新世代潮酷出行方式，真的要放弃吗？",
            btns: [
              {
                text: "去意已决",
                key: "close",
              },
              {
                text: "我再想想",
                key: "cancel",
                type: "active",
              },
            ],
            onClick: (props, ev, self) => {
              if (props.key === "cancel") {
                // 取消重新打开
                this.$emit("input", true);
              }
              self.appender &&
                typeof self.appender.close === "function" &&
                self.appender.close();
            },
          });
        }
      },
    },
  },
  methods: {
    loopStatus() {
      getStatus(this.detail.carOrderBaseId).then((res) => {
        if (res.data === false || res.data === "false") {
          this.timer = setTimeout(() => {
            this.loopStatus();
          }, 4000);
        } else {
          location.href = `paySuccess.html?id=${this.detail.carOrderBaseId}`;
        }
      });
    },
  },
  mounted() {
    // longPressSave("box", "scanimg");
  },
};
</script>

<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
.dialog-body {
  position: relative;
  .dialog-body-content {
    overflow: hidden;
    border-radius: 10px;
    background: #fff;
  }
  .content {
    width: 295px;
    padding: 20px;
    max-width: 80vw;
    overflow: hidden;
  }
}

.close {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 26px;
  .title {
    font-size: 20px;
    line-height: 32px;
  }
  .icon-close {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}

.box {
  font-size: 14px;
  color: #000;
  text-align: center;
  .img {
    width: 170px;
    height: 170px;
  }
  .price {
    font-size: 36px;
    font-weight: 400;
    line-height: 58px;
    margin: 13px 0;
    &::before {
      content: "￥";
      font-size: 18px;
      font-weight: 400;
      line-height: 28px;
    }
  }
  .scan {
    display: flex;
    align-items: center;
    justify-content: center;
    .scan-img {
      width: 24px;
      height: 21px;
      margin-right: 5px;
    }
    .scan-text {
      font-weight: bold;
    }
  }
  .save-text {
    display: none;
    @include media(
      (
        $md: (
          margin-top: 30px,
          display: block,
        ),
      )
    );
  }
}
</style>
